/**
 * User-facing copy for the Add Interviewers field. Centralised per the
 * hardcoded-copy standard so phrasing (and straight-vs-curly apostrophes)
 * stays consistent and is ready for future i18n.
 */

export const ADD_INTERVIEWER_LABEL = 'Add interviewer';
export const AVAILABILITY_LABEL = 'Availability';
export const HOURS_UNIT = 'hrs';
export const NOTE_LABEL = 'Note:';
export const RECOMMENDED_LABEL = 'Recommended';
export const LOOKING_FOR_BEST_INTERVIEWER =
  'Looking for the best interviewer...';
export const RECOMMENDED_INTERVIEWER_HEADING =
  'Recommended interviewer for this interview:';
export const NO_RECOMMENDATION_MESSAGE =
  "We couldn't recommend the ideal interviewer from the interviewers configured in the interview plan based on their working hours, calendar availability, and weekly interviewing hours. Please add an interviewer manually.";
export const CALENDAR_NOT_CONNECTED_TOOLTIP =
  'This user hasn’t connected their calendar yet.';

// react-select option group headings.
export const SELECTED_INTERVIEWERS_GROUP = 'selected interviewers';
export const ALL_INTERVIEWERS_GROUP = 'all interviewers';

// "No slots available" messaging — one template per variant, driven by whether
// a single interviewer or a group is unavailable.
export const getUnavailableInterviewersMessage = (
  isSingle: boolean,
  name?: string
): string =>
  `${isSingle ? `${name} is` : 'Interviewers are'} not available in the selected date range`;

export const getAdjustSelectionMessage = (isSingle: boolean): string =>
  `Choose ${
    isSingle ? 'another interviewer' : 'other interviewers'
  }, modify your date range or select slots manually`;
